import languagesContent from './languages.json'
import { getLanguageCode } from '../utils/helpers'

const { languages } = languagesContent

const translations: Record<string, string> =
  getLanguageCode() === 'zh' ? { ...languages['en-US'], ...languages['zh-CN'] } : languages['en-US']

/**
 * toI18N is use to translate a key
 *
 * @returns
 */
export function toI18N(key: string) {
  return translations[key] || key
}

/**
 * formatI18nKeys is use to  translate a key with variable
 * If not enough arguments are provided for a variable we will display the placeholder (%1$s)
 *
 *
 * @param {...Array<string>} args
 * @returns {string}
 */
export function formatI18nKeys(key: string, ...args: Array<any>): string {
  let value = toI18N(key)
  for (let i = 0; i < args.length; i++) {
    const varIndex = i + 1
    value = value.replace(`%${varIndex}$s`, args[i])
  }
  return value
}
